export const isChatUpdates = (
  notifications: any[],
  projectUuid: string
): boolean =>
  notifications?.some(
    (notification: any) =>
      notification.data?.project.uuid === projectUuid &&
      notification.type === 'newChatMessage'
  )
